import React, {memo, useRef, useState} from 'react';
import classNames from "classnames";
import PropTypes from 'prop-types';
import {Tooltip} from "reactstrap";

const IdColumn = memo(({product}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const idRef = useRef(null);
  const tooltipId = `tooltip-id-${product.id}`;

  const handleCopyId = () => {
    navigator.clipboard.writeText(product.id).then(() => {
      setTooltipOpen(true);
      setTimeout(() => setTooltipOpen(false), 1500);
    });
  };

  return (
    <td className="pt-4">
      <p id={tooltipId}
         ref={idRef}
         className={classNames({
           'cursor-pointer': true,
           'text-center': true,
           'ms-4': true,
           'text-gray': !product.status
         })}
         onClick={handleCopyId}
      >
        {product.id}
        <Tooltip
          placement="top"
          target={tooltipId}
          trigger="manual"
          isOpen={tooltipOpen}
          delay={{"show": 0, "hide": 100}}
        >
          Copied
        </Tooltip>
      </p>
    </td>
  );
});

IdColumn.propTypes = {
  product: PropTypes.object.isRequired,
};

export default IdColumn;
